import type { SxProps, Theme } from '@mui/material';

export const stickySidebarMenuSx: SxProps<Theme> = theme => ({
  width: '100%',
  m: 0,
  p: '5px',
  overflow: 'auto',
  backgroundColor: 'background.paper',
  border: 0,
  borderRadius: '4px',
  [theme.breakpoints.up('md')]: { display: 'block', justifyContent: 'space-between' },
  [theme.breakpoints.up('lg')]: { maxHeight: 'calc(100vh - 110px)' },
  '& ul': {
    m: 0,
    p: '11px',
    [theme.breakpoints.up('md')]: { width: '205px', p: '15px' },
  },
});

export const sidebarMenuItemSx: SxProps<Theme> = theme => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: 'auto',
  m: 0,
  mr: '15px',
  mb: '12px',
  p: 0,
  pl: '24px',
  color: 'text.primary',
  fontSize: '14px',
  background: 'none',
  border: 0,
  cursor: 'pointer',
  textDecoration: 'none',
  [theme.breakpoints.up('md')]: {
    width: '100%',
    mr: 0,
  },
  '&:last-of-type': { mb: 0 },
  '&.static': { pointerEvents: 'none' },
  '& + .left-menu-subitems:empty:last-child': { mt: '-12px' },
  '&:hover, &:active, &:focus, &[aria-current="page"]': {
    color: 'primary.main',
    outline: 'none',
    textDecoration: 'none',
  },
  '& i': {
    position: 'absolute',
    left: 0,
    fontSize: '17px',
    opacity: 0.7,
  },
  '& svg': { position: 'absolute', left: '-2px', width: '20px', height: '20px' },
  '& > span': {
    [theme.breakpoints.up('md')]: {
      display: 'inline',
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      overflowWrap: 'normal',
    },
  },
});

export const sidebarSubitemsSx: SxProps<Theme> = {
  display: 'none',
  '.tabs-btn[aria-current="page"] + &': { display: 'block' },
  '&:last-child .left-menu-subitem:last-child, &:last-child .tabs-btn:last-child': { mb: 0 },
  '& .tabs-btn': {
    position: 'relative',
    display: 'block',
    mb: '5px',
    pl: '24px',
    color: 'inherit',
    textTransform: 'capitalize',
    '&:first-of-type': { mt: '-5px' },
    '&:last-of-type': { mb: '20px' },
    '&:hover': { textDecoration: 'underline' },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-2px',
      left: '7px',
      width: '1px',
      height: 'calc(100% + 5px)',
      backgroundColor: 'text.primary',
      opacity: 0.35,
    },
    '&[aria-current="page"]': { color: 'primary.main', textDecoration: 'none' },
  },
};
